import VSelect from './VSelect.vue';

export { VSelect };
export default VSelect;
